export default "__VITE_ASSET__D3el_krx__"